import { Platform } from 'react-native';

import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes';

const style = {
  ...Platform.select({
    ios: {
      shadowColor: Colors.linegrey,
      shadowOffset: {
        width: 0,
        height: 5,
      },
      shadowRadius: 5,
      shadowOpacity: 0.4,
    },
    android: {
      shadowColor: Colors.black,
      elevation: 6,
    },
  }),
};
export default style;
